module.exports = __webpack_public_path__ + "static/media/Polygon.9a0d73b6.svg";